import React, { FC } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import BundleCourseHeaderSkeleton from './skeleton/BundleCourseHeaderSkeleton';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import useBundleCourse from '@hooks/bundle/useBundleCourse';
import useBundleCourseItemsModal from '@hooks/bundle/useBundleCourseItemsModal';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';
import { useBreakpointV2 } from '@helpers/use';

type BundleCourseHeaderProps = {
  bundleDetailSeo: BundleEntity;
};

const BundleCourseHeader: FC<BundleCourseHeaderProps> = ({ bundleDetailSeo }) => {
  const theme = useTheme();
  const { t } = useTranslation('store_course');

  const { isMobile } = useBreakpointV2();
  const { courseDetailSeo, isCourseDetailSeoLoading } = useBundleCourse();
  const { isCourseEnrolledByIdName } = useBundleCourseItemsModal();
  const isEnrolled = isCourseEnrolledByIdName(courseDetailSeo?.idName);

  const RenderIsEnrolledBadge = (
    <Box
      sx={{
        width: '107px',
        height: '28px',
        backgroundColor: theme.palette.success.main,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '24px',
        marginBottom: 1,
      }}
    >
      <Box
        color={theme.palette.textOnPrimary.primary}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '3px',
        }}
      >
        <FontAwesomeIcon icon="fa-light fa-circle-check" style={{ fontSize: '16px' }} />
        <Typography variant="tagTextBold">{t('bundle_detail.bundle_course_items.content.card.enrolled')}</Typography>
      </Box>
    </Box>
  );

  if (isCourseDetailSeoLoading) {
    return <BundleCourseHeaderSkeleton />;
  }

  return (
    <Box>
      {isEnrolled && RenderIsEnrolledBadge}
      <Typography variant={isMobile ? 'body2' : 'h4'} color={theme.palette.textV2.secondary}>
        {t('bundle_detail.bundle_course_items.course.modal.title', { bundleName: bundleDetailSeo.name })}
      </Typography>
      <Typography variant={isMobile ? 'h3v2' : 'h1'} color={theme.palette.textV2.primary}>
        {courseDetailSeo.name}
      </Typography>
    </Box>
  );
};

export default BundleCourseHeader;
